// extracted by mini-css-extract-plugin
export default {"button":"ButtonSecondary_button__VyMdh"};